import { useEffect, useState } from 'react';
import { useNavegate } from 'App/hooks';
import { useModal } from 'commons/hooks';
import { useHasNuvemDomainEnabled } from '../../../hooks';

export function useAddDomainModalLogic() {
  const { getQueryParam, removeSearchParams } = useNavegate();
  const hasNuvemDomainEnabled = useHasNuvemDomainEnabled();

  const [showAddDomainModal, openAddDomainModal, closeAddDomainModalBase] =
    useModal(false);
  const [
    showPurchaseDomainModal,
    openPurchaseDomainModal,
    closePurchaseDomainModalBase,
  ] = useModal(false);

  const [initialSearchQuery, setInitialSearchQuery] = useState<
    string | undefined
  >(undefined);

  const closeAddDomainModal = () => {
    setInitialSearchQuery(undefined);
    closeAddDomainModalBase();
  };

  const closePurchaseDomainModal = () => {
    setInitialSearchQuery(undefined);
    closePurchaseDomainModalBase();
  };

  // Reset purchase modal state if feature is disabled
  useEffect(() => {
    if (!hasNuvemDomainEnabled && showPurchaseDomainModal) {
      closePurchaseDomainModalBase();
      setInitialSearchQuery(undefined);
    }
  }, [
    hasNuvemDomainEnabled,
    showPurchaseDomainModal,
    closePurchaseDomainModalBase,
  ]);

  // Capture query params for initial search
  useEffect(() => {
    const searchParam = getQueryParam('search');
    const openSearchParam = getQueryParam('openSearch');

    if (
      (searchParam || openSearchParam) &&
      hasNuvemDomainEnabled &&
      !showPurchaseDomainModal
    ) {
      setInitialSearchQuery(searchParam || '');
      openPurchaseDomainModal();
      removeSearchParams(['search', 'openSearch']);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasNuvemDomainEnabled]);

  const handleOpenModal = () => {
    if (hasNuvemDomainEnabled) {
      openPurchaseDomainModal();
    } else {
      openAddDomainModal();
    }
  };

  return {
    hasNuvemDomainEnabled,
    showAddDomainModal,
    showPurchaseDomainModal,
    initialSearchQuery,
    setInitialSearchQuery,
    openAddDomainModal,
    openPurchaseDomainModal,
    closeAddDomainModal,
    closePurchaseDomainModal,
    handleOpenModal,
  };
}
